"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getQueryParams = exports.fixedEncodeURIComponent = exports.getQueryStringParams = exports.resolve = exports.replaceParams = exports.deserialize = exports.paramsToString = exports.getGoogleMapsAddressLink = void 0;
exports.getGoogleMapsAddressLink = (p) => {
    const urlAddress = encodeURIComponent(p.street + " " + p.zip + " " + p.city + " " + p.country.name);
    const url = "https://www.google.com/maps/?q=" + urlAddress;
    return url;
};
exports.paramsToString = (params) => Object.keys(params)
    .map((key) => key + "=" + encodeURIComponent(params[key]))
    .join("&");
exports.deserialize = (str) => str.split(",").reduce((r, item) => {
    const arr = item.split("=");
    if (arr.length === 2) {
        const [key, value] = arr;
        return { ...r, [key]: value };
    }
    else
        return r;
}, {});
exports.replaceParams = (uri, params, curly = false) => {
    if (!params || !(typeof params === "object")) {
        return uri;
    }
    Object.entries(params).map(([key, value]) => {
        if (curly) {
            const regex = new RegExp(`\\$\\{${key}\\}`, "g");
            uri = uri.replace(regex, value);
        }
        else
            uri = uri.replace(`:${key}`, value);
    });
    return uri;
};
exports.resolve = (hostIn, pathIn) => {
    const re = /^(.*)\/[^\/]*$/;
    const hostMatch = hostIn.match(re);
    let host = hostMatch && hostMatch[1];
    if ((host === "http:/" || host === "https:/") && !hostIn.endsWith("/")) {
        host = hostIn;
    }
    const reSlash = /^\/{0,1}(.*)$/;
    const pathMatch = pathIn.match(reSlash);
    const path = pathMatch && pathMatch[1];
    if (host && path) {
        return `${host}/${path}`;
    }
    else
        return null;
};
exports.getQueryStringParams = (query) => {
    if (!query) {
        return {};
    }
    return (/^[?#]/.test(query) ? query.slice(1) : query)
        .split("&")
        .reduce((params, param) => {
        const arrSplit = param.split("=");
        const [key, value] = arrSplit;
        params[key] = value ? decodeURIComponent(value.replace(/\+/g, " ")) : "";
        return params;
    }, {});
};
exports.fixedEncodeURIComponent = (str) => encodeURIComponent(str).replace(/[!'()*]/g, (c) => {
    return "%" + c.charCodeAt(0).toString(16);
});
exports.getQueryParams = (s) => {
    if (!s || typeof s !== "string" || s.length < 2) {
        return new Map();
    }
    const a = s
        .substr(1)
        .split("&")
        .map((x) => {
        const a = x.split("=");
        return [a[0], a[1]];
    });
    return new Map(a);
};
